import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  toast,
  Tooltip,
  Tr,
  useDisclosure,
  useMediaQuery,
  useToast
} from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { AxiosResponse } from 'axios';
import { format, getTime } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import exportFromJSON from 'export-from-json';
import {
  forwardRef,
  useContext,
  useEffect,
  useLayoutEffect,
  useState
} from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DatePicker from 'react-datepicker';
import {
  AiOutlineArrowLeft,
  AiOutlineCalendar,
  AiOutlineEye,
  AiOutlineMail,
  AiOutlineSearch,
  AiOutlineWhatsApp
} from 'react-icons/ai';
import { BiDownArrowAlt } from 'react-icons/bi';
import { BsFillArrowDownSquareFill } from 'react-icons/bs';
import { FiClock } from 'react-icons/fi';
import { IoIosAlert } from 'react-icons/io';
import { IoEyeOffOutline } from 'react-icons/io5';
import { MdOutlineFileCopy } from 'react-icons/md';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import { FireIcon } from '../../../../../assets/icons/FireIcon';
import { DatePickerExport } from '../../../../../components/datepicker/DatePickerExport';
import { StepsLead } from '../../../../../components/white-label/StepsLead';
import {
  LeadBtnTooltipComponent,
  TooltipComponent
} from '../../../../../components/widgets/Tooltip';
import FilterContext, {
  FiltersType
} from '../../../../../contexts/FilterContext';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import useUpdateEffect from '../../../../../hooks/useUpdateEffect';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getProductName } from '../../../../../utils/leads.util';
import KanbanFilters from '../../kanban/partials/KanbanFilters';
import { getTelephoneOrCellPhoneNumber } from '../utils/getTelephoneOrCellPhoneNumber';

type LeadStatus =
  | 'Novas Oportunidades'
  | 'NovoContato'
  | 'EmNegociacao'
  | 'Concluido';

type ShowOrHidePhoneProps = {
  phone: string;
  celphone: string;
  canShow: boolean;
};

const dateFnsDayPeriod = {
  'da manhã': 'Manhã',
  'da tarde': 'Tarde',
  'da noite': 'Noite'
};

function KanbanVendedor() {
  const fromBackendOportunidades = [];
  const initalFilters: FiltersType = {
    query: {
      status: '',
      'data-inicial': '',
      'data-final': '',
      campanha: '',
      'abordagem-n2': '',
      produto: '',
      'produto-atual': '',
      abordagem: '',
      nome: '',
      email: '',
      telefone: '',
      celular: ''
    },
    headers: {
      cpf: '',
      cnpj: ''
    }
  };
  const cards = {
    [uuid()]: {
      name: 'Novas Oportunidades',
      color: '#001E64',
      items: fromBackendOportunidades,
      id: 1,
      status: 'Oportunidades'
    },
    [uuid()]: {
      name: 'Agendado',
      color: '#001E64',
      items: [],
      id: 2,
      status: 'NovoContato'
    },
    [uuid()]: {
      name: 'Em negociação',
      color: '#001E64',
      items: [],
      id: 3,
      status: 'EmNegociacao'
    },
    [uuid()]: {
      name: 'Concluído',
      color: '#001E64',
      items: [],
      id: 4,
      status: 'Concluido'
    }
  };
  const {
    isOpen: isOpenDetails,
    onOpen: onOpenDetails,
    onClose: onCloseDetails
  } = useDisclosure();
  const { state }: any = useLocation();

  const navigate = useNavigate();

  const [details, setDetails] = useState<any>({
    name: '',
    email: '',
    cel: '',
    campaign: '',
    id: '',
    status: '',
    cpf: '',
    id_mdm: '',
    data_criacao: 0,
    segmento: '',
    lote: '',
    data_campanha: '',
    objetivo_campanha: '',
    descritivo_campanha: ''
  });
  const [leads, setLeads] = useState(cards);
  const [changeVendedor, setChangeVendedor] = useState(state.vendedor);
  const {
    currentPageOportunidades,
    setCurrentPageOportunidades,
    currentPageNovoContato,
    setCurrentPageNovoContato,
    currentPageEmNegociacao,
    setCurrentPageEmNegociacao,
    currentPageConcluido,
    setCurrentPageConcluido,
    filterTextState,
    setFilterTextState,
    filterSelectState,
    setFilterSelectState,
    filtersState,
    setFiltersState,
    filterObject,
    orderBy,
    setFilterObject,
    setLoadingFilters
  } = useContext(FilterContext);
  const [filterLink, setFilterLink] = useState({ query: '', headers: {} });

  const [isLoadingInfiniteScroll, setIsLoadingInfiniteScroll] = useState(false);

  const [listaVendedores, setListaVendedores] = useState<
    {
      id?: string;
      tipo?: string;
      nome?: string;
      id_vendedor?: string;
      login?: string;
    }[]
  >([]);
  const [idVendedor, setIdVendedor] = useState('');
  const toast = useToast();

  const [values, setValues] = useState({
    quantidade_leads_totais: 0,
    quantidade_leads_visualizados: 0,
    quantidade_leads_nao_visualizados: 0,
    quantidade_leads_agendamento_em_atraso: 0,
    quantidade_leads_vendas_realizadas: 0,
    quantidade_leads_vendas_nao_realizadas: 0
  });

  const [startDate, setStartDate] = useState<any>(null);
  // eslint-disable-next-line react/display-name
  const CustomDatepicker = forwardRef(({ value, onClick }: any, ref: any) => (
    <button
      className=" tw-border-[#001E64] tw-border-[0.1rem] tw-px-4 tw-py-2 tw-rounded-full tw-bg-white tw-flex tw-items-center"
      onClick={onClick}
      ref={ref}
    >
      {startDate !== null ? value : '--/--/--'}{' '}
      <span className="tw-ml-4">
        <AiOutlineCalendar size="1.2rem" />
      </span>
    </button>
  ));
  const [nomeVendedor, setNomeVendedor] = useState('');
  const [historyLoading, setHistoryLoading] = useState(false);
  const [loadingExportingData, setLoadingExportData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState<any>([{}]);
  const { visualizationState, setVisualizationState, setFetchUserTypeState } =
    useContext(VisualizationContext);
  const [isMobile] = useMediaQuery('(max-width: 920px)');
  const [qtdState, setQtdState] = useState<any>({
    'Novas Oportunidades': 0,
    Agendado: 0,
    'Em negociação': 0,
    Concluído: 0
  });
  const [loadingPagination, setLoadingPagination] = useState({
    novasOportunidades: false,
    novoContato: false,
    emNegociacao: false,
    concluido: false
  });

  const getLoadingStatus = (colName: string) => {
    if (colName === 'Novas Oportunidades') {
      return loadingPagination.novasOportunidades;
    }
    if (colName === 'Agendado') {
      return loadingPagination.novoContato;
    }
    if (colName === 'Em negociação') {
      return loadingPagination.emNegociacao;
    }
    if (colName === 'Concluído') {
      return loadingPagination.concluido;
    }
  };

  const searchVisualized = (user: string, arrayVisualized: any) => {
    if (arrayVisualized) {
      const seller = arrayVisualized.find((lead) => {
        return lead === user;
      });
      if (seller) {
        return <IoEyeOffOutline size="1.1rem" />;
      }
      return <AiOutlineEye size="1.1rem" />;
    }
    return <IoEyeOffOutline size="1.1rem" />;
  };

  const getVisualizedStatus = (
    user: string,
    arrayVisualized: any
  ): 'visualizado' | 'nao-visualizado' => {
    if (arrayVisualized) {
      const seller = arrayVisualized.find((lead) => {
        return lead === user;
      });
      if (seller) {
        return 'nao-visualizado';
      }
      return 'visualizado';
    }
    return 'nao-visualizado';
  };

  const objStatusPages = [
    {
      status: 'Novas Oportunidades',
      currentPage: currentPageOportunidades
    },
    { status: 'NovoContato', currentPage: currentPageNovoContato },
    { status: 'EmNegociacao', currentPage: currentPageEmNegociacao },
    { status: 'Concluido', currentPage: currentPageConcluido }
  ];

  const getQtdData = async () => {
    const { data } = await apiSensedia.get(
      `oportunidades-sulamerica/painel-leads/leads/indicadores`,
      {
        headers: {
          login:
            changeVendedor.id_vendedor ||
            changeVendedor.id ||
            changeVendedor.login
        }
      }
    );

    setValues({ ...data });
  };

  const getColorStatus = (lead, where) => {
    switch (true) {
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        !where:
        return '#006217';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        where === 'bg':
        return 'tw-bg-[#006217]';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        !where:
        return '#AA2C23';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        where === 'bg':
        return 'tw-bg-[#AA2C23]';
      case lead?.SOLICITOU_CONTATO__c === 'true' && !where:
        return '#FF5000';
      case lead?.SOLICITOU_CONTATO__c === 'true' && where === 'bg':
        return 'tw-bg-[#FF5000]';
      case where === 'bg':
        return 'tw-bg-[#001E64]';
      default:
        return '#001E64';
    }
  };

  const getFiltersPath = (lastItem: string | undefined, leadStatus: string) => {
    const path = lastItem
      ? `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&status=${leadStatus}&cursor=${lastItem}`
      : `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&status=${leadStatus}`;
    return path;
  };

  const getFiltersModalPath = (leadStatus: string, lastItem: string) => {
    let queryStatus = '';
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }

    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === '' ||
        filter === 'status'
      ) {
        delete filterFormatQuery[filter];
      }
    }
    const filterURL = '' + new URLSearchParams(filterFormatQuery).toString();

    queryStatus =
      `${filterURL !== '' ? filterURL : ''}` + '&status=' + leadStatus;

    const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&${queryStatus}&cursor=${lastItem}`;

    return path;
  };

  const handleCarregarDados = async () => {
    try {
      const perfis = await apiSensedia.get(
        '/oportunidades-sulamerica/painel-leads/gestao/perfis'
      );

      setListaVendedores(perfis?.data || []);
    } catch (error) {
      console.log(error);
    }
    // setVendedoresDisponiveis([...state.perfis]);
    setNomeVendedor(state.vendedor.nome);
    setChangeVendedor(state.vendedor);
    setIdVendedor(state.vendedor.id);

    setLoading(true);

    setCurrentPageOportunidades(1);
    setCurrentPageNovoContato(1);
    setCurrentPageEmNegociacao(1);
    setCurrentPageConcluido(1);

    try {
      let orderByObject = {};
      if (orderBy.direcao !== '') {
        orderByObject = {
          ...orderBy
        };
      }
      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(getFiltersPath(undefined, params.status), {
                params: {
                  'tipo-consulta': 'kanban',
                  ...orderByObject
                },
                headers: {
                  login:
                    changeVendedor.id_vendedor ||
                    changeVendedor.id ||
                    changeVendedor.login
                }
              });
            }
          })
          .filter((item) => Boolean(item))
      );

      const leadsObj = {};
      const indicadoresObj = {};
      const tipo = responses[0].data.tipo;

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });
      const objTest = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objTest.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objTest.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objTest.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objTest.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };
      setQtdState(indicadoresObj);
      setLeads(cards);
      setLoading(false);
    } catch (error) {
      console.log(error);
      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: [],
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: [],
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: [],
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: [],
          id: 4,
          status: 'Concluido'
        }
      };
      setLeads(cards);
      setLoading(false);
    }
  };

  const setReason = (reason: string) => {
    switch (reason) {
      case 'nao-atendeu':
        return 'Não Atendeu';
      case 'sem-interesse':
        return 'Cliente sem interesse';
      case 'retorno-cliente':
        return 'Aguardando retorno do cliente';
      case 'transmissao':
        return 'Transmissão Realizada';
      case 'preco-alto':
        return 'Preço Alto (Recusa)';
      case 'outra-operadora':
        return 'Optou por outra operadora (Recusa)';
      case 'recusa-credenciada':
        return 'Recusa pela rede credenciada';
      case 'contato-incorreto':
        return 'Dados de contato incorreto';
      case 'retornar-depois':
        return 'Pediu para retornar mais tarde';
      case 'retomado':
        return 'Cliente retomado';
      default:
        return '';
    }
  };

  const copyText = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
      position: 'bottom',
      description: 'Texto copiado com sucesso.',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const handleFilters = async (id_vendedor) => {
    setLoading(true);
    setLoadingFilters(true);
    // setVendedoresDisponiveis([...state.perfis]);
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }
    const filterFormatHeader = {
      ...filterObject.headers
    };

    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === ''
      ) {
        delete filterFormatQuery[filter];
      }
    }

    for (const filter in filterFormatHeader) {
      if (
        filterFormatHeader[filter] === null ||
        filterFormatHeader[filter] === ''
      ) {
        delete filterFormatHeader[filter];
      }
    }
    const filterURL = '&' + new URLSearchParams(filterFormatQuery).toString();

    const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100&${
      filterURL !== '&' ? filterURL : ''
    }`;

    setCurrentPageOportunidades(1);
    setCurrentPageNovoContato(1);
    setCurrentPageEmNegociacao(1);
    setCurrentPageConcluido(1);

    if (filterFormatQuery.status) {
      const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=100${
        filterURL !== '&' ? filterURL : ''
      }`;

      const { data } = await apiSensedia.get(path, {
        headers: { ...filterFormatHeader, login: id_vendedor }
      });
      const objLeads = {
        concluidos:
          data.leads.filter((lead) => lead.STATUS__c === 'Concluido') || [],
        emNegociacao:
          data.leads.filter((lead) => lead.STATUS__c === 'EmNegociacao') || [],
        novoContato:
          data.leads.filter((lead) => lead.STATUS__c === 'NovoContato') || [],
        oportunidades:
          data.leads.filter(
            (lead) => lead.STATUS__c === 'Novas Oportunidades'
          ) || []
      };

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objLeads.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objLeads.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objLeads.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objLeads.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };
      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLeads(cards);
      setLoading(false);
      setLoadingFilters(false);
      return;
    } else {
      const path = `${filterURL !== '&' ? filterURL : ''}`;

      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(
                getFiltersPath(undefined, params.status) + path,
                {
                  headers: {
                    ...filterFormatHeader,
                    login: id_vendedor
                  }
                }
              );
            }
          })
          .filter((item) => Boolean(item))
      );

      const leadsObj = {};
      const indicadoresObj = {};
      const tipo = responses[0].data.tipo;

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });

      const objLeads = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };

      const cards = {
        [uuid()]: {
          name: 'Novas Oportunidades',
          color: '#001E64',
          items: objLeads.oportunidades,
          id: 1,
          status: 'Oportunidades'
        },
        [uuid()]: {
          name: 'Agendado',
          color: '#001E64',
          items: objLeads.novoContato,
          id: 2,
          status: 'NovoContato'
        },
        [uuid()]: {
          name: 'Em negociação',
          color: '#001E64',
          items: objLeads.emNegociacao,
          id: 3,
          status: 'EmNegociacao'
        },
        [uuid()]: {
          name: 'Concluído',
          color: '#001E64',
          items: objLeads.concluidos,
          id: 4,
          status: 'Concluido'
        }
      };
      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLeads(cards);
      setQtdState(indicadoresObj);
      setLoading(false);
      setLoadingFilters(false);
    }
  };

  const handleMudarVendedor = async (val: any) => {
    const [id_vendedor, tipo] = val.split('::');

    if (tipo === 'gestor') {
      setFetchUserTypeState(false);
      navigate('/corretor/leads');
    }

    setLoading(true);
    const vendedor = listaVendedores.find((element: any) => {
      return element.id_vendedor === id_vendedor;
    });
    setIdVendedor(vendedor.id);
    // setVendedoresDisponiveis([...state.perfis]);
    setNomeVendedor(vendedor?.nome || '');
    setChangeVendedor(vendedor);
    await handleFilters(vendedor.id_vendedor);
    setLoading(false);
  };

  const getPerfis = async () => {
    try {
      let looping = true;

      while (looping) {
        try {
          const { data } = await apiSensedia.get(
            `/oportunidades-sulamerica/painel-leads/gestao/perfis`,
            {
              timeout: 0
            }
          );
          setListaVendedores(data);
          looping = false;
        } catch (e: any) {
          if (e.response.status == 500) {
            console.log('ocorreu internal server error', e.response.statusText);
            console.log('ocorreu internal server error', e.response.data);
          } else if (e.response.status == 504) {
            console.log('ocorreu gateway timeout', e.response.data);
          }
          if (e.response.status !== 504) {
            looping = false;
          }
        }
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const loadMoreCards = async (status: string, id: string) => {
    const statusMapping = {
      Oportunidades: 'Novas Oportunidades'
    };

    const formattedStatus: LeadStatus = statusMapping[status] || status;

    const currentPage = objStatusPages.map((statusPage) => {
      if (statusPage.status === formattedStatus) {
        return statusPage.currentPage + 1;
      }
    });

    const currentPageFiltered = currentPage.find(
      (item) => item !== null && item !== undefined
    );

    if (
      (formattedStatus === 'Novas Oportunidades' &&
        loadingPagination.novasOportunidades) ||
      (formattedStatus === 'NovoContato' && loadingPagination.novoContato) ||
      (formattedStatus === 'EmNegociacao' && loadingPagination.emNegociacao) ||
      (formattedStatus === 'Concluido' && loadingPagination.concluido)
    )
      return;

    setIsLoadingInfiniteScroll(true);

    try {
      switch (formattedStatus) {
        case 'Novas Oportunidades':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novasOportunidades: true
          }));
          break;
        case 'NovoContato':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novoContato: true
          }));
          break;
        case 'EmNegociacao':
          setLoadingPagination((prevState) => ({
            ...prevState,
            emNegociacao: true
          }));
          break;
        case 'Concluido':
          setLoadingPagination((prevState) => ({
            ...prevState,
            concluido: true
          }));
          break;
      }

      let response;
      if (filterObject === initalFilters) {
        response = await apiSensedia.get(
          getFiltersPath(
            leads[id].items[leads[id].items.length - 1].ID_LEAD__c,
            formattedStatus
          ),
          {
            params: {
              'tipo-consulta': 'kanban'
            },
            headers: {
              login:
                changeVendedor.id_vendedor ||
                changeVendedor.id ||
                changeVendedor.login
            }
          }
        );
      } else {
        response = await apiSensedia.get(
          getFiltersModalPath(
            formattedStatus,
            leads[id].items[leads[id].items.length - 1].ID_LEAD__c
          ),
          {
            params: {
              'tipo-consulta': 'kanban'
            },
            headers: {
              ...filterLink.headers,
              login:
                changeVendedor.id_vendedor ||
                changeVendedor.id ||
                changeVendedor.login
            }
          }
        );
      }
      switch (formattedStatus) {
        case 'Novas Oportunidades':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novasOportunidades: false
          }));
          setCurrentPageOportunidades(currentPageFiltered);
          break;
        case 'NovoContato':
          setLoadingPagination((prevState) => ({
            ...prevState,
            novoContato: false
          }));
          setCurrentPageNovoContato(currentPageFiltered);
          break;
        case 'EmNegociacao':
          setLoadingPagination((prevState) => ({
            ...prevState,
            emNegociacao: false
          }));
          setCurrentPageEmNegociacao(currentPageFiltered);
          break;
        case 'Concluido':
          setLoadingPagination((prevState) => ({
            ...prevState,
            concluido: false
          }));
          setCurrentPageConcluido(currentPageFiltered);
          break;
      }

      const obj1 = leads[id];
      const obj2 = response.data.leads;

      const mergedObj = {
        ...obj1,
        items: [...obj1.items, ...obj2]
      };

      const newLeads = {
        ...leads,
        [id]: mergedObj
      };

      setLeads(newLeads);
    } catch (error) {
      console.log(error);
    }

    setIsLoadingInfiniteScroll(false);
  };

  const handleScroll = (event: any, item: any, id: string) => {
    const div = event.target;
    const status = item.status;
    const valScroll = Math.trunc(div.scrollHeight - div.scrollTop);
    const atBottom =
      valScroll === div.clientHeight || valScroll === div.clientHeight + 1;

    if (atBottom) {
      loadMoreCards(status, id);
    }
  };

  const ShowOrHidePhone = ({
    phone,
    celphone,
    canShow
  }: ShowOrHidePhoneProps) => {
    const formatCel = (number = '') => {
      if (!number) return '';

      let formating = String(number).replace(/\D/g, '');

      formating = formating.replace(/^0/, '');

      if (formating.length >= 12) {
        formating = formating.slice(2);
        if (formating.length === 10) {
          formating = formating.replace(
            /^(\d\d)(\d{4})(\d{4}).*/,
            '($1) $2-$3'
          );
          return formating;
        }
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length === 11) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 10) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 5) {
        formating = formating.replace(
          /^(\d\d)(\d{4})(\d{0,4}).*/,
          '($1) $2-$3'
        );
      } else if (formating.length > 2) {
        formating = formating.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
      } else {
        formating = formating.replace(/^(\d*)/, '($1)');
      }
      return formating;
    };

    const getTelephoneOrCellPhoneNumber = (telephone: any, cell: any) => {
      const telephoneFormatted = telephone?.replace(/\D/g, '');
      const cellFormatted = cell?.replace(/\D/g, '');

      let phoneNumber = '';

      if (
        cellFormatted &&
        telephoneFormatted &&
        telephoneFormatted?.length >= 10 &&
        cellFormatted?.length >= 10
      ) {
        phoneNumber = `${cellFormatted} / ${telephoneFormatted}`;
      } else if (telephoneFormatted && telephoneFormatted?.length >= 10) {
        phoneNumber = `${telephoneFormatted}`;
      } else if (cellFormatted && cellFormatted?.length >= 10) {
        phoneNumber = `${cellFormatted}`;
      } else {
        phoneNumber = '';
      }

      return phoneNumber;
    };
    if (!canShow) {
      const ddd = phone.slice(0, 2);

      return (
        <>
          <p>{ddd}</p>
          <div className="tw-w-[5.73188rem] tw-h-[1.48188rem] tw-bg-[#ececec] tw-blur-[2px]" />
        </>
      );
    } else return <p>{getTelephoneOrCellPhoneNumber(phone, celphone)}</p>;
  };

  const checkHasVisualization = (
    userId: string,
    USUARIOS_VISUALIZACOES__c: string[]
  ) => {
    return USUARIOS_VISUALIZACOES__c?.includes(userId);
  };

  useEffect(() => {
    getPerfis();
    handleCarregarDados();
  }, []);

  useLayoutEffect(() => {
    getQtdData();
  }, [changeVendedor]);

  useEffect(() => {
    const initial = JSON.stringify(initalFilters);
    const filters = JSON.stringify(filterObject);

    if (initial !== filters) {
      handleFilters(
        changeVendedor.id_vendedor || changeVendedor.id || changeVendedor.login
      );
    }
  }, [filterObject, orderBy]);
  return (
    <>
      <Box margin="0" p="13px 0 20px 0" bg="#ebebeb" position="relative">
        <Box
          mt="1rem"
          display="flex"
          w="100%"
          justifyContent="start"
          alignItems="start"
        >
          {' '}
          {state.disableReturnButton ? (
            <></>
          ) : (
            <div className="tw-mb-[2vh] tw-px-[3.5rem] tw-absolute tw-top-0">
              <Link to={'/corretor/leads/perfis'}>
                <button className="tw-font-bold tw-text-[#001E64]">
                  <Icon as={AiOutlineArrowLeft} mr="0.5rem" />
                  Voltar
                </button>
              </Link>
            </div>
          )}
        </Box>
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            px="3.5rem"
            alignItems="center"
          >
            <Box
              display="flex"
              flexDir="column"
              justifyContent="start"
              alignItems="start"
              gap="10px"
            >
              <Text fontSize="1.5rem" fontWeight="bold">
                Painel de Gestão de Leads
              </Text>
              <Box display="flex" w="100%" alignItems="center" gap="0.7rem">
                <Text fontSize="1.2rem">
                  Vendedor: <span className="tw-font-bold">{nomeVendedor}</span>
                </Text>
                <Box w="196px" border="1px solid #FF5000" borderRadius="2rem">
                  <Select
                    bg="white"
                    fontWeight="bold"
                    fontSize="1rem"
                    color="#FF5000"
                    textAlign="center"
                    borderRadius="2rem"
                    h="2.3rem"
                    onChange={(e) => {
                      handleMudarVendedor(e.target.value);
                    }}
                  >
                    <option value="" disabled selected>
                      Alterar Vendedor
                    </option>
                    {listaVendedores.map((vendedor) => {
                      return (
                        <>
                          <option
                            value={`${
                              vendedor.id_vendedor || vendedor.login
                            }::${vendedor.tipo}`}
                            className="tw-text-[black]"
                          >
                            {vendedor.nome}
                          </option>
                        </>
                      );
                    })}
                  </Select>
                </Box>
              </Box>
            </Box>
            <div>
              <div className="tw-font-bold">Alterar modo de visualização</div>
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex tw-gap-1">
                  <div>
                    <Link to="/corretor/leads/">
                      <input
                        name="options"
                        value="gestao"
                        onChange={(e) => {
                          setVisualizationState(e.target.value);
                        }}
                        type="radio"
                        defaultChecked={visualizationState === 'gestao'}
                        className="tw-text-2xl tw-font-bold tw-mb-4"
                      />
                    </Link>
                  </div>
                  <div>Modelo de Gestão</div>
                </div>
                <div className="tw-flex tw-gap-1">
                  <div>
                    <Link to="/corretor/leads/">
                      <input
                        name="options"
                        type="radio"
                        value="card"
                        onChange={(e) => {
                          setVisualizationState(e.target.value);
                        }}
                        defaultChecked={visualizationState === 'card'}
                        className="tw-text-2xl tw-font-bold tw-mb-4"
                      />
                    </Link>
                  </div>
                  Modelo de Cards
                </div>
              </div>
            </div>
          </Box>
        </>
      </Box>
      <Box
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        mt="1rem"
      >
        <Box
          display="flex"
          w="97vw"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            w="21.5vw"
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
            h={!isMobile ? '17vh' : ' 13vh'}
            bg={'#fff'}
            border={'0'}
            borderRadius="0.8rem"
            display="flex"
            pb="2vh"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
            mr={!isMobile ? '24px' : '10px'}
          >
            <Text
              fontWeight="bold"
              color={'gray.900'}
              fontSize={!isMobile ? '7vh' : ' 5vh'}
            >
              {!loading ? (
                values.quantidade_leads_nao_visualizados
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Text
                fontSize={!isMobile ? '2.5vh' : ' 1.5vh'}
                color={'gray.900'}
                align="center"
              >
                Leads sem visualização
              </Text>
            </Box>
          </Box>
          <Box
            w={!isMobile ? '21.5vw' : '30vw'}
            h={!isMobile ? '17vh' : ' 13vh'}
            bg="#fff"
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
            borderRadius="0.8rem"
            display="flex"
            pb="2vh"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
            mr={!isMobile ? '24px' : '10px'}
          >
            <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
              {!loading ? (
                values.quantidade_leads_agendamento_em_atraso
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={!isMobile ? '2.5vh' : ' 1.4vh'} align="center">
              Leads agendamento em atraso
            </Text>
          </Box>
          <Box
            w={!isMobile ? '21.5vw' : '30vw'}
            h={!isMobile ? '17vh' : ' 13vh'}
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
            bg="#fff"
            borderRadius="0.8rem"
            display="flex"
            pb="2vh"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
              {!loading ? (
                values.quantidade_leads_vendas_realizadas
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={!isMobile ? '2.5vh' : ' 1.5vh'} align="center">
              Vendas realizadas
            </Text>
          </Box>
          <Box
            w={!isMobile ? '21.5vw' : '30vw'}
            h={!isMobile ? '17vh' : ' 13vh'}
            bg="#fff"
            borderRadius="0.8rem"
            display="flex"
            alignItems="center"
            boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
            justifyContent="center"
            flexDir="column"
            pb="2vh"
            ml={!isMobile ? '24px' : '10px'}
          >
            <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
              {!loading ? (
                values.quantidade_leads_vendas_nao_realizadas
              ) : (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              )}
            </Text>
            <Text fontSize={!isMobile ? '2.5vh' : ' 1.5vh'} align="center">
              Vendas não realizadas
            </Text>
          </Box>
        </Box>
        <div className="tw-mt-5">
          <KanbanFilters
            login={
              changeVendedor.id_vendedor ||
              changeVendedor.id ||
              changeVendedor.login
            }
          />
        </div>
        {!loading && (
          <DragDropContext
            onDragEnd={(result) => {
              // onDragEnd(result, leads, setLeads);
            }}
          >
            {!loading ? (
              <HStack>
                {Object.entries(leads).map(([columnId, column], index) => {
                  return (
                    <Box key={columnId}>
                      <StepsLead
                        color={`${column.color}`}
                        text={column.name}
                        value={qtdState[column.name]}
                      />
                      <Box
                        ml="2vh"
                        mt="2vh"
                        pointerEvents={
                          getLoadingStatus(column.name) ? 'none' : undefined
                        }
                      >
                        <Droppable droppableId={columnId} key={columnId}>
                          {(provided) => {
                            if (column.items.length <= 0) {
                              return (
                                <Box
                                  display="flex"
                                  flexDir="column"
                                  h="80vh"
                                  w={{ base: '20vw', sm: '19vw' }}
                                  border="dashed rgba(0, 0, 0, 0.15) 0.13rem"
                                  alignItems="center"
                                  justify="center"
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  <Box
                                    mt="15vh"
                                    display="flex"
                                    flexDirection="column"
                                    align="center"
                                  >
                                    {/* <VectorIcon />
                                        <Text w="10vw" fontSize="2vh" mt="1vh">
                                          Clique e arraste os cards para alterar o
                                          status
                                        </Text> */}
                                  </Box>
                                  {provided.placeholder}
                                </Box>
                              );
                            }
                            return (
                              <Box
                                display="flex"
                                flexDir="column"
                                h="80vh"
                                w={{ base: '19vw', sm: '19vw' }}
                                overflowY="scroll"
                                overflowX="hidden"
                                onScroll={(e) => {
                                  handleScroll(e, column, columnId);
                                }}
                                alignItems="center"
                                sx={{
                                  '&::-webkit-scrollbar': {
                                    width: '0.4rem',
                                    borderRadius: '8px',
                                    backgroundColor: `rgba(0, 0, 0, 0.05)`
                                  },
                                  '&::-webkit-scrollbar-thumb': {
                                    borderRadius: '8px',
                                    backgroundColor: `#939393`
                                  }
                                }}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {column.items.map((item, index) => {
                                  return (
                                    <Draggable
                                      key={item.ID_LEAD__c}
                                      draggableId={item.ID_LEAD__c}
                                      index={index}
                                    >
                                      {(provided) => {
                                        return (
                                          <Box
                                            display="flex"
                                            flexDir="column"
                                            bg="#fff"
                                            borderRadius="1.5vh"
                                            justify="flex-start"
                                            m="1vh"
                                            borderLeft={`${getColorStatus(
                                              item,
                                              null
                                            )} solid 0.5vh`}
                                            w={{ base: '18vw' }}
                                            p="2vh"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                          >
                                            <Box
                                              display="flex"
                                              alignItems="flex-start"
                                              justifyContent="space-between"
                                            >
                                              <Box
                                                fontWeight="bold"
                                                fontSize="2.1vh"
                                                textAlign={'start'}
                                              >
                                                {item.NOME__c || ''}
                                              </Box>
                                              <Box>
                                                {item?.SOLICITOU_CONTATO__c && (
                                                  <FireIcon
                                                    w="1.5rem"
                                                    h="2rem"
                                                  />
                                                )}
                                              </Box>
                                            </Box>
                                            {item?.PDN_Reaberto__c === true && (
                                              <Box my="0.4rem">
                                                <Text
                                                  bg={getColorStatus(
                                                    item,
                                                    null
                                                  )}
                                                  px="0.4rem"
                                                  w={'max-content'}
                                                  minW="3rem"
                                                  whiteSpace={'nowrap'}
                                                  borderRadius={'1rem'}
                                                  py="0.1rem"
                                                  textAlign={'center'}
                                                  color={'white'}
                                                >
                                                  {item?.PDN_Reaberto__c ===
                                                  true
                                                    ? 'Lead Reaberto'
                                                    : ''}
                                                </Text>
                                              </Box>
                                            )}
                                            {item.EMAIL__c && (
                                              <Box
                                                display="flex"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                fontSize="2vh"
                                                mb="0.4rem"
                                                cursor="pointer"
                                                onClick={() => {
                                                  copyText(item.EMAIL__c);
                                                }}
                                              >
                                                <Box
                                                  mr="0.4rem"
                                                  fontSize="1.6vh"
                                                  overflowWrap="break-word"
                                                  wordBreak="break-word"
                                                >
                                                  {item.EMAIL__c}
                                                </Box>
                                                <MdOutlineFileCopy
                                                  size="1.9vh"
                                                  color="grey"
                                                />
                                              </Box>
                                            )}
                                            {getTelephoneOrCellPhoneNumber(
                                              item.TELEFONE__c,
                                              item.CELULAR__c
                                            ) && (
                                              <Box
                                                display="flex"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                mb="0.4rem"
                                                fontSize="1.6vh"
                                                overflowWrap="break-word"
                                                wordBreak="break-word"
                                                cursor="pointer"
                                                onClick={() => {
                                                  checkHasVisualization(
                                                    item.LOGIN__c,
                                                    item.USUARIOS_VISUALIZACOES__c
                                                  ) &&
                                                    copyText(
                                                      getTelephoneOrCellPhoneNumber(
                                                        item.TELEFONE__c,
                                                        item.CELULAR__c
                                                      )
                                                    );
                                                }}
                                              >
                                                <ShowOrHidePhone
                                                  phone={item.TELEFONE__c || ''}
                                                  celphone={
                                                    item.CELULAR__c || ''
                                                  }
                                                  canShow={checkHasVisualization(
                                                    item.LOGIN__c,
                                                    item.USUARIOS_VISUALIZACOES__c
                                                  )}
                                                />
                                                <MdOutlineFileCopy
                                                  size="1.9vh"
                                                  color="grey"
                                                />
                                              </Box>
                                            )}

                                            {item.Campanha__c ===
                                            'Sem Campanha' ? (
                                              <></>
                                            ) : (
                                              <Box
                                                my="1.5vh"
                                                p="0.1rem"
                                                borderRadius="1rem"
                                                bg={`${getColorStatus(
                                                  item,
                                                  null
                                                )}`}
                                                w={{ base: '9vw', sm: '13vw' }}
                                                fontSize="1.5vh"
                                                textColor="#fff"
                                                display="flex"
                                                justifyContent="center"
                                              >
                                                <span>
                                                  {item.Campanha__c?.length >=
                                                  20
                                                    ? item.Campanha__c?.substring(
                                                        0,
                                                        28
                                                      ) + '...'
                                                    : item.Campanha__c}
                                                </span>
                                              </Box>
                                            )}
                                            {item?.PRODUTOS__c?.length > 0 ? (
                                              <Flex
                                                alignItems={'start'}
                                                flexDirection="column"
                                                my="0.4rem"
                                              >
                                                <p className="tw-font-bold">
                                                  Produto
                                                </p>

                                                <Flex flexWrap={'wrap'} gap={2}>
                                                  {item.PRODUTOS__c.map(
                                                    (product, index) => {
                                                      return (
                                                        <Text
                                                          key={index}
                                                          bg={getColorStatus(
                                                            item,
                                                            null
                                                          )}
                                                          px="0.4rem"
                                                          w={'max-content'}
                                                          whiteSpace={'nowrap'}
                                                          borderRadius={'1rem'}
                                                          py="0.1rem"
                                                          color={'white'}
                                                        >
                                                          {getProductName(
                                                            product
                                                          ) || ''}
                                                        </Text>
                                                      );
                                                    }
                                                  )}
                                                </Flex>
                                              </Flex>
                                            ) : (
                                              <Flex
                                                alignItems={'start'}
                                                flexDirection="column"
                                                my="0.4rem"
                                              >
                                                <Text
                                                  fontWeight="bold"
                                                  w="100%"
                                                  textAlign={'left'}
                                                >
                                                  Produto
                                                </Text>
                                                <Text
                                                  bg={getColorStatus(
                                                    item,
                                                    null
                                                  )}
                                                  px="0.4rem"
                                                  w={'max-content'}
                                                  minW="3rem"
                                                  whiteSpace={'nowrap'}
                                                  borderRadius={'1rem'}
                                                  py="0.1rem"
                                                  textAlign={'center'}
                                                  color={'white'}
                                                >
                                                  {getProductName(
                                                    item.PDN_ProdutoAtual__c
                                                  ) || '-'}
                                                </Text>
                                              </Flex>
                                            )}
                                            {item?.NOME_CORRETOR__c && (
                                              <Box
                                                my="0.4rem"
                                                w={'100%'}
                                                textAlign={'left'}
                                              >
                                                <Text fontWeight="bold">
                                                  Corretora
                                                </Text>
                                                <Text>
                                                  {item.NOME_CORRETOR__c || ''}
                                                </Text>
                                              </Box>
                                            )}
                                            {item?.DATA_AGENDAMENTO__c &&
                                              item?.STATUS__c ===
                                                'NovoContato' && (
                                                <Box
                                                  p="0.1rem"
                                                  borderRadius="1rem"
                                                  fontSize="0.8rem"
                                                  display="flex"
                                                  flexDir={'column'}
                                                  alignItems="start"
                                                  mb="0.4rem"
                                                >
                                                  <Text
                                                    fontSize="1rem"
                                                    fontWeight={'bold'}
                                                  >
                                                    Agendamentos
                                                  </Text>
                                                  <Flex ml="0.3rem" gap="1">
                                                    <span>
                                                      {format(
                                                        new Date(
                                                          item
                                                            .DATA_AGENDAMENTO__c
                                                            ?._seconds * 1000 ||
                                                            0
                                                        ),
                                                        'dd/MM/yyyy'
                                                      )}{' '}
                                                      às{' '}
                                                      {format(
                                                        new Date(
                                                          item
                                                            .DATA_AGENDAMENTO__c
                                                            ?._seconds * 1000 ||
                                                            0
                                                        ),
                                                        'HH:mm'
                                                      )}{' '}
                                                      -{' '}
                                                    </span>
                                                    <Text
                                                      bg="#001E64"
                                                      w="fit-content"
                                                      textColor={'white'}
                                                      px="0.3rem"
                                                      rounded={'md'}
                                                    >
                                                      {
                                                        dateFnsDayPeriod[
                                                          format(
                                                            new Date(
                                                              item
                                                                .DATA_AGENDAMENTO__c
                                                                ?._seconds *
                                                                1000 || 0
                                                            ),
                                                            'B',
                                                            { locale: ptBR }
                                                          )
                                                        ]
                                                      }
                                                    </Text>
                                                  </Flex>
                                                </Box>
                                              )}
                                            {item?.ABORDAGEM_N2__c &&
                                              item?.STATUS__c ===
                                                'EmNegociacao' && (
                                                <Flex
                                                  alignItems={'start'}
                                                  flexDirection="column"
                                                  my="0.4rem"
                                                >
                                                  <Text fontWeight="bold">
                                                    Em Negociação
                                                  </Text>
                                                  <Text>
                                                    {item?.ABORDAGEM_N2__c ===
                                                      'cotacao' &&
                                                      'Cotação enviada'}
                                                    {item?.ABORDAGEM_N2__c ===
                                                      'transmissao' &&
                                                      'Proposta transmitida'}
                                                  </Text>
                                                </Flex>
                                              )}
                                            {item?.ABORDAGEM_N2__c &&
                                              item?.STATUS__c === 'Concluido' &&
                                              item?.ABORDAGEM__c === false && (
                                                <Flex
                                                  alignItems={'start'}
                                                  flexDirection="column"
                                                  my="0.4rem"
                                                >
                                                  <Text fontWeight="bold">
                                                    Motivo
                                                  </Text>
                                                  <Text>
                                                    {setReason(
                                                      item?.ABORDAGEM_N2__c
                                                    )}
                                                  </Text>
                                                </Flex>
                                              )}
                                            <LeadBtnTooltipComponent
                                              tooltip={
                                                getVisualizedStatus(
                                                  item.LOGIN__c,
                                                  item.USUARIOS_VISUALIZACOES__c
                                                ) === 'visualizado'
                                                  ? 'Lead visualizado'
                                                  : 'Lead não visualizado'
                                              }
                                              side="bottom"
                                              arrowOffset={100}
                                            >
                                              <Box
                                                display="flex"
                                                justifyContent="flex-start"
                                              >
                                                <Link
                                                  state={{
                                                    isGestor: true,
                                                    vendedor: changeVendedor
                                                  }}
                                                  to={
                                                    '/corretor/leads/' +
                                                    item.ID_LEAD__c
                                                  }
                                                  className={`tw-flex tw-items-center tw-gap-2 tw-justify-center tw-w-[100%] tw-text-center tw-h-[5vh] tw-cursor-pointer tw-text-white tw-rounded-full tw-font-[1.8vh] ${getColorStatus(
                                                    item,
                                                    'bg'
                                                  )}`}
                                                >
                                                  {searchVisualized(
                                                    item.LOGIN__c,
                                                    item.USUARIOS_VISUALIZACOES__c
                                                  )}
                                                  <span> Ver Detalhes</span>
                                                </Link>
                                              </Box>
                                            </LeadBtnTooltipComponent>
                                          </Box>
                                        );
                                      }}
                                    </Draggable>
                                  );
                                })}
                                {provided.placeholder}
                              </Box>
                            );
                          }}
                        </Droppable>
                        {getLoadingStatus(column.name) ? (
                          <HStack justifyContent="center">
                            <Spinner />
                          </HStack>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </HStack>
            ) : (
              <Flex w="100%" justify="center">
                <Spinner />
              </Flex>
            )}
          </DragDropContext>
        )}

        <Box borderBottom="1px solid #E3E3E3" w="100%" h="0" mt="1rem" />
      </Box>
    </>
  );
}

export default KanbanVendedor;
